<!-- 臭氧监测 -->
<!--
  设备统计组件
-->

<template>
  <div class="ozone_monitor">
    <ContentSection :title="'臭氧监测'" :mainStyle="{ borderLeftStyle: 'solid' }" :position="'right'">
      <header>
        <div>
          <img src="@/assets/img/ozone_hearder.png" alt="" srcset="">
          <p>
            <span class="name">氧气泄露</span>
            <span class="value">{{data[0]&&data[0].Value}}</span>
            <span class="unit">{{ data[0]&&data[0].Unit }}</span>
          </p>
          <img src="@/assets/img/ozone_hearder.png" alt="" srcset="">
        </div>
        <div>
          <img src="@/assets/img/ozone_hearder.png" alt="" srcset="">
          <p>
            <span class="name">臭氧泄漏</span>
            <span class="value">{{data[1]&&data[1].Value}}</span>
            <span class="unit">{{data[1]&&data[1].Unit}}</span>
          </p>
          <img src="@/assets/img/ozone_hearder.png" alt="" srcset="">
        </div>
      </header>

      <ul>
        <li>
          <div class="index">1#</div>
          <p> <span class="name">臭氧发生器实时产量：</span>
            <span class="value">{{data[2]&&data[2].Value}}</span>
            <span class="unit">{{data[2]&&data[2].Unit}}</span>
          </p>
        </li>
        <div class="line"></div>
        <li>
          <div class="index">2#</div>
          <p> <span class="name">臭氧发生器实时产量：</span>
            <span class="value">{{data[3]&&data[3].Value}}</span>
            <span class="unit">{{data[3]&&data[3].Unit}}</span>
          </p>
        </li>
        <div class="line"></div>
        <li>
          <div class="index">3#</div>
          <p> <span class="name">臭氧发生器实时产量：</span>
            <span class="value">{{data[4]&&data[4].Value}}</span>
            <span class="unit">{{data[4]&&data[4].Unit}}</span>
          </p>
        </li>
      </ul>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from "@/components/ContentSection";
import {singleDeviceRealApi,listDeviceRealApi} from '@/api/basic.js'
export default {
  name: "devStat",
  components: {
    ContentSection,
  },
  data() {
    return {
      // data:{
      //   oxygen:12, // 氧气泄露
      //   ozone:12,  // 臭氧泄露
      //   realProuce1:12, // 臭氧发生器实时产量1
      //   realProuce2:12, // 臭氧发生器实时产量2
      //   realProuce3:12, // 臭氧发生器实时产量3
      // }
      data:[
        {
          Value:12,
          Unit:'%',
        },
        {
          Value:8,
          Unit:'ppm',
        },
        {
          Value:20,
          Unit:'kg/h',
        },
        {
          Value:18,
          Unit:'kg/h',
        },
        {
          Value:17,
          Unit:'kg/h',
        },
      ]
    };
  },
  mounted() {
    // this.getData()
  },
  methods: {
    getData(){
      this.data = []
      // 请求的id: 氧气泄露,臭氧泄露,臭氧发生器实时产量1,臭氧发生器实时产量2,臭氧发生器实时产量3
      const equipmentids = 'fe3df72b-4f0a-43f9-a608-f60c100325a2,6ffcdc12-26ee-4cf0-88e8-30e701899fcd,47aabf57-a437-47f3-9744-69624de995a2,2ff00d61-7db3-419d-bf5f-e7d4db632b45,567b6997-172f-4e8d-ae79-10e13188dbdf'
      // listDeviceRealApi({equipmentids}).then(res=>{
        let res = listDeviceRealApi()
        if (res.errorcode == 0) {
          console.log(res.resultdata.rows)
          res.resultdata.rows.map(item=>{
            this.data.push(item.ListParam[0])
          })
        }
      // })
    }
  },
};
</script>

<style lang='less' scoped>
.ozone_monitor {
  .value {
    font-size: 50px;
    margin: 0 20px;
    font-family: PMZ;
  }

  header {
    width: 814px;
    display: flex;
    justify-content: space-between;
    margin: auto;
    margin-top: 52px;
    color: #e8f4ff;
    font-family: '黑体';

    div {
      width: 395.6px;
      height: 88px;
      border-radius: 5vw * @vw;
      background-image: radial-gradient(rgba(28, 138, 255, 0.49), rgba(28, 138, 255, 0));
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        width: 49px;

        &:last-child {
          transform: scaleX(-1);
        }
      }

      .name {
        font-size: 29px;
      }


      .unit {
        font-size: 30px;
      }
    }
  }

  ul {
    width: 806px;
    margin: auto;
    margin-top: 59px;
    li {
      height: 92px;
      background-image: linear-gradient(to right, rgba(13, 147, 255, 0.6), rgba(09, 119, 255, 0.17));
      position: relative;
      color: #fff;
      font-size: 30px;

      .index {
        width: 131px;
        height: 73px;
        background-image: url('@/assets/img/ozone_index_back.png');
        background-size: 100% 100%;
        position: absolute;
        top: -12px;
        left: -12px;
        font-size: 35px;
        color: #0099ff;
        font-weight: bold;
      }
      p{
        float: right;
        margin-right: 60px;
        margin-top: 18px;
        .name,.unit{
         font-weight: bold;
        }
      }
    }
    
    .line{
        height: 0;
        margin: 25px 0;
        border-top: 2vw *@vw dashed #93d0ff;
      }
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
.ozone_monitor {
  .value {
    font-size: 26px;
  }

  header {
    width: 554px;
    margin-top: 0px;
    div {
      width: 300px;
      height: 88px;
      img {
        width: 26px;
        &:last-child {
          transform: scaleX(-1);
        }
      }

      .name {
        font-size: 20px;
      }


      .unit {
        font-size: 30px;
      }
    }
  }

  ul {
    width: 606px;
    margin: auto;
    margin-top: 1px;
    li {
      height: 36px;
      font-size: 22px;
      // line-height: 36px;
      .index {
        width: 60px;
        height: 36px;
        top: -1px;
        left: -1px;
        font-size: 20px;
      }
      p{
        float: right;
        margin-right: 120px;
        margin-top: 2px;
      }
    }  
    .line{
        margin: 13px 0;
      }
  }
  }
}
</style>